export default "__VITE_ASSET__WhqvES3O__"